function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "40",
  height: "40",
  rx: "20",
  fill: "#DE4949"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.6 12.8a1.8 1.8 0 00-3.6 0v9a1.8 1.8 0 003.6 0v-9zM21.6 27.2a1.8 1.8 0 10-3.6 0 1.8 1.8 0 003.6 0z",
  fill: "#fff"
}));